import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { deepPurple, indigo, teal, grey } from "@mui/material/colors";

let theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: indigo[600],
      light: indigo[400],
      dark: indigo[800],
      contrastText: "#ffffff",
    },
    secondary: {
      main: deepPurple[500],
      light: deepPurple[300],
      dark: deepPurple[700],
      contrastText: "#ffffff",
    },
    success: { main: teal[600] },
    background: {
      default: "#f6f7fb",
      paper: "#ffffff",
    },
    text: {
      primary: grey[900],
      secondary: grey[700],
    },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: [
      "Inter",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      "Oxygen",
      "Ubuntu",
      "Cantarell",
      '"Fira Sans"',
      '"Droid Sans"',
      '"Helvetica Neue"',
      "sans-serif",
    ].join(","),
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 10 },
      },
    },
    MuiCard: {
      styleOverrides: { root: { borderRadius: 14 } },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;



